export default __webpack_public_path__ + "static/media/12.657db61b.jpg";